import { render, staticRenderFns } from "./BookMetrics.vue?vue&type=template&id=a3df5c92&"
import script from "./BookMetrics.vue?vue&type=script&lang=js&"
export * from "./BookMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports